import { render, staticRenderFns } from "./RemainingDaysBadge.vue?vue&type=template&id=d1dc9fba&scoped=true"
import script from "./RemainingDaysBadge.vue?vue&type=script&lang=ts"
export * from "./RemainingDaysBadge.vue?vue&type=script&lang=ts"
import style0 from "./RemainingDaysBadge.vue?vue&type=style&index=0&id=d1dc9fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1dc9fba",
  null
  
)

export default component.exports